































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ButtonDefault } from '@/components/parts/button';
import { Svgbase, Question } from '@/components/svgicon';
import ExtLink from '@/components/ext/Link.vue';
import BracketsList from './components/BracketsList.vue';
import SidebarElement from './components/SidebarElement.vue';
import LinkElement from './components/LinkElement.vue';
import YesNo from './components/YesNo.vue';
import Share from '@/components/parts/share';
import {
  Locations,
  ComponentProps,
  StringOrObject,
  QuestionLinkHash,
  PartnerLinkTypes,
  EducationFormList,
  MunicipalityLinkQuery,
} from './types';
import { AppSvgIconNew } from '@/uikit';

@Component({
  components: {
    AppSvgIconNew,
    YesNo,
    Share,
    Svgbase,
    ExtLink,
    Question,
    LinkElement,
    BracketsList,
    ButtonDefault,
    SidebarElement,
  },
})
export default class ComponentsPartsCatalogCardComponentsSidebar
  extends Vue
  implements ComponentProps
{
  // Props
  @Prop({ type: Array, default: () => [] })
  geo: Locations;

  @Prop({ type: String, default: '' })
  title: string;

  @Prop({ type: Array, default: () => [] })
  locations: Locations;

  @Prop({ type: String, default: '' })
  disease: string;

  @Prop({ type: String, default: '' })
  metro: string;

  @Prop({ type: String, default: '' })
  educationForm: string;

  @Prop({ type: String, default: '' })
  laborProgram: string;

  @Prop({ type: String, default: '' })
  educationMode: string;

  @Prop({ type: String, default: '' })
  educationCategory: string;

  @Prop({ type: String, default: '' })
  programmType: string;

  @Prop({ type: String, default: '' })
  finishResult: string;

  @Prop({ type: Array, default: null })
  municipalityLink: Array<MunicipalityLinkQuery>;

  @Prop({ type: Array, default: '' })
  municipalityName: Array<string>;

  @Prop({ type: Object, default: null })
  questionLink: QuestionLinkHash;

  @Prop({ type: [String, Object], default: null })
  certificateLink: StringOrObject;

  @Prop({ type: Object, default: null })
  partnerLink: PartnerLinkTypes;

  @Prop({ type: String, default: '' })
  partnerName: string;

  @Prop({ type: String, default: '' })
  partnerPhone: string;

  @Prop({ type: String, default: '' })
  partnerEmail: string;

  @Prop({ type: String, default: '' })
  partnerSite: string;

  @Prop({ type: String, default: '' })
  partnerId: string;

  @Prop({ type: Boolean, default: false })
  isLinkSite: boolean;

  @Prop({ type: Boolean, required: true })
  isOvz: true;

  @Prop({ type: Array, default: () => [] })
  ovzDiseases: Array<string>;

  @Prop({ type: Boolean, default: false })
  isFree: boolean;

  @Prop({ type: Boolean, default: false })
  isOpen: boolean;

  @Prop({ type: Boolean, default: false })
  isDot: boolean;

  @Prop({ type: String, default: '' })
  cost: string;

  @Prop({ type: String, default: '' })
  eduDocName: string;

  // data
  public educationFormList = EducationFormList;

  // computed
  get hasMunicipality() {
    return this.municipalityLink && this.municipalityName;
  }

  // get hasPartner() {
  //   return this.partnerLink && this.partnerName;
  // }
  get partner() {
    return (
      this.$store.state.organizators.find((el: { id: string; }) => el.id === this.partnerId) ||
      null
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/card/components/sidebar/Sidebar.vue